import { FeaturedFilter, FilterParams, UrlFilters, SecondaryFilter } from "./types";
import { CardOrientationQueryParam } from "../../../components/Results/CardOrientation/constants";

const ignoredNames = ["page", "business", CardOrientationQueryParam];

export const isValidFilterName = (name: string): boolean => /^([a-z0-9]+)(-[a-z0-9]+)*$/.test(name);

const parsePrimaryFilters = (slugPath = ""): FeaturedFilter[] =>
  slugPath.split("/").filter(isValidFilterName);

const parseSecondaryFilters = (params: SecondaryFilter): SecondaryFilter =>
  Object.keys(params)
    .filter(filter => ignoredNames.indexOf(filter) === -1)
    .reduce<SecondaryFilter>((acum, key) => ({ ...acum, [key]: params[key] }), {});

export const parseFilterParams = (params: FilterParams): UrlFilters => {
  const { filter, ...otherParams } = params;
  return {
    featured: parsePrimaryFilters(filter),
    secondary: parseSecondaryFilters(otherParams)
  };
};
